module.exports = __webpack_public_path__ + "media/recipes/38-025b0702.png";